import React from 'react';
interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  align?: 'left' | 'center';
}
export function SectionHeading({
  title,
  subtitle,
  align = 'left'
}: SectionHeadingProps) {
  const isCenter = align === 'center';
  return <div className={isCenter ? 'mx-auto max-w-2xl text-center' : 'max-w-2xl'} data-id="element-218" data-mp="3f2wxhmr351x8">
      <div aria-hidden="true" className={`h-px w-16 bg-neon/70 ${isCenter ? 'mx-auto' : ''}`} data-id="element-219" data-mp="3k0yfe4cryv74" />
      <h2 className="mt-6 text-3xl font-semibold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-220" data-mp="bl5bcozmrc6y">
        {title}
      </h2>
      {subtitle ? <p className="mt-4 text-base leading-relaxed text-mist-muted" data-id="element-221" data-mp="1v3og0j0jztm">{subtitle}</p> : null}
    </div>;
}